import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { forwardRef } from 'react';
import { classNames } from '../../helpers/classnames.js';
import { Icon } from '../Icon/Icon.js';
import { Button } from '../Button/Button.js';
import '../Button/ProgressButton/ProgressButton.js';

var IconButton = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, iconName = _a.iconName, className = _a.className, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'IconButton' : _d, props = __rest(_a, ["size", "iconName", "className", "type", "dataTestId"]);
    return (React__default.createElement(Button, __assign({ "data-testid": dataTestId }, props, { className: classNames('dsb_icon-button', "dsb_icon-button__".concat(size), className), type: type, size: size, startIcon: React__default.createElement(Icon, { className: "dsb_icon-button-start-icon", size: size, iconName: iconName }), ref: ref })));
});

export { IconButton };
